import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const r = i((o, a) => /* @__PURE__ */ e.jsx(
  s,
  {
    ref: a,
    ...o,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zm-15.165-6.387h-2.988V20h2.906q1.225 0 2.133-.533a3.6 3.6 0 0 0 1.406-1.512q.492-.978.492-2.262 0-1.23-.462-2.15a3.3 3.3 0 0 0-1.348-1.436q-.891-.51-2.139-.51m1.084 6.498q-.498.375-1.271.375h-.961v-5.344h.949q1.137 0 1.693.68.558.68.557 1.886 0 .768-.234 1.395a2.16 2.16 0 0 1-.733 1.008",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
r.displayName = "DesonideIcon";
export {
  r as DesonideIcon,
  r as default
};
//# sourceMappingURL=index.js.map
